import {
  fulfillmentType,
  type FulfillmentOrderLike,
  type FulfillmentType,
} from '@/lib/fulfillment'

// Delivery / Pickup pill for the unified fulfillment queue. Delivery keeps the
// app's existing purple convention; pickup is teal. Type is derived (no BE
// field) via fulfillmentType — see docs/fulfillment-roadmap.md §2.1.
const TYPE_PILL: Record<FulfillmentType, { label: string; className: string }> = {
  delivery: { label: 'Delivery', className: 'bg-purple-100 text-purple-700' },
  pickup: { label: 'Pickup', className: 'bg-teal-100 text-teal-700' },
}

export function FulfillmentTypePill({ order }: { order: FulfillmentOrderLike }) {
  const { label, className } = TYPE_PILL[fulfillmentType(order)]
  return (
    <span className={`px-2 py-1 text-xs font-medium rounded-full ${className}`}>
      {label}
    </span>
  )
}
